import { BrowserRouter, Routes, Route } from 'react-router-dom'

import NavBar from './components/Navbar'
import Footer from './components/Footer'

// import Home from './pages/home/Home'
import About from './pages/about/About'
import Contact from './pages/contact/Contact'
import Process from './pages/process/Process'
import NotFound from './pages/notFound/NotFound'
import Welcome from './pages/welcome/Welcome'


const App = () => {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route index element={<Welcome />} />
        {/* <Route index element={<Home />} /> */}
        <Route path='about' element={<About />} />
        <Route path='process' element={<Process />} />
        <Route path='contact' element={<Contact />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  )
}

export default App